import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../../shared/global';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class MakePaymentService {
	// rest api url
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest=GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private payment_url = this.baseApiUrl + 'api/rest/v1/auth/payment/';
  private payment_url = this.baseApiUrlTest + 'api/payment/post/payment';
  // private first_payment_url = this.baseApiUrl + 'api/rest/v1/auth/token-payment/';
  // private payment_location_url = this.baseApiUrl + 'api/rest/v1/get/locations/';
  // private barcode_image_url = this.baseApiUrl + 'api/rest/v1/download/barcode/';
  private barcode_image_url = this.baseApiUrlTest + 'api/payment/download/barcode';
  // private track_first_payment = this.baseApiUrl + 'api/rest/v1/check/bonus/';
  // private get_card = this.baseApiUrl + 'api/rest/v1/get/card/detail/';
  private get_card = this.baseApiUrlTest + 'api/ManageCard/get/card/detail';
  private get_payment_profiles = this.baseApiUrlTest + 'api/payment/processor/profiles'
  constructor(private http: Http, private localStorageService: LocalStorageService) { }
  paymentPay(card_detail: Object) {
    return this.http
    .post(this.payment_url, card_detail)
    .toPromise()
    .then(res => res.json())
    .catch(this.handleError);
  }
  // paymentFirstPay(card_detail: Object) {
  //   return this.http
  //   .post(this.first_payment_url, card_detail)
  //   .toPromise()
  //   .then(res => res.json())
  //   .catch(this.handleError);
  // }
  // trackFirstPayment(username: Object) {
  //     return this.http
  //       .post(this.track_first_payment, username)
  //       .toPromise()
  //       .then(res => res.json())
  //       .catch(this.handleError);
  // }
  getCard(token: Object) {
      return this.http
        .post(this.get_card, token)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }
  fetchPaymentProfiles(token: string) {
    return this.http
      .get(this.get_payment_profiles + '?token=' + token)
      .toPromise()
      .then(res => res.text())
      .catch(this.handleError);
  }
  // paymentLocations(token: Object) {
  //     return this.http
  //       .post(this.payment_location_url, token)
  //       .toPromise()
  //       .then(res => res.json())
  //       .catch(this.handleError);
  // }
  barcodeImage(user_number: Object) {
      return this.http
        .post(this.barcode_image_url, user_number)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/make-payment/make-payment.service.ts